import React from 'react';
import classNames from 'classnames';

type StatisticItem = {
  label: string;
  className?: string;
  value: number | string;
};

type StatisticsSummaryProps = {
  items: StatisticItem[];
  className?: string;
};

export const StatisticsSummary: React.FC<StatisticsSummaryProps> = ({
  items,
  className,
}) => {
  return (
    <div className={classNames('statistics-summary', className)}>
      {items.map((item, index) => (
        <div key={index} className={classNames('statistics-summary__item')}>
          <div className={classNames('statistics-summary__label')}>
            {item.label}
          </div>

          <div
            className={classNames('statistics-summary__value', item.className)}
          >
            {item.value}
          </div>
        </div>
      ))}
    </div>
  );
};
